const fetchData = async (endpoint: string) => {
  try {
    let jsonResponse: any
    let response = await fetch(endpoint)
    if (response.status >= 200 && response.status <= 299) {
      jsonResponse = await response.json()
    } else {
      throw Error(response.statusText)
    }

    return jsonResponse
  } catch (error) {
    console.error(error)
  }
}

const postData = async (endpoint: string, body: {}, type = 'json') => {
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: type === 'json' ? JSON.stringify(body) : body
    })

    if (!response.ok) {
      const errorData = await response.json().catch(() => null)
      throw new Error(errorData?.message || response.statusText || 'Request failed')
    }

    return await response.json()
  } catch (error) {
    throw error
  }
}

export { fetchData, postData }
